<template>
  <div class="admin-layout">
    <aside class="sidebar">
      <div class="sidebar__brand">
        <div class="sidebar__logo">
          <img src="/mondial_logo.png" alt="Mondial90" class="sidebar__logo-img" />
        </div>
        <span class="sidebar__title">Mondial90</span>
      </div>
      <nav class="sidebar__nav">
        <router-link
          :to="{ name: 'Dashboard' }"
          class="sidebar__link"
          :class="{ 'sidebar__link--active': isManageMenuActive }"
        >
          <span class="material-symbols-outlined">menu</span>
          <span>Manage Menu</span>
        </router-link>
        <router-link :to="{ name: 'Pages' }" class="sidebar__link" active-class="sidebar__link--active">
          <span class="material-symbols-outlined">description</span>
          <span>Pages</span>
        </router-link>
        <router-link :to="{ name: 'Materijali' }" class="sidebar__link" active-class="sidebar__link--active">
          <span class="material-symbols-outlined">layers</span>
          <span>Materials</span>
        </router-link>
        <router-link :to="{ name: 'Galerija' }" class="sidebar__link" active-class="sidebar__link--active">
          <span class="material-symbols-outlined">photo_library</span>
          <span>Galerija</span>
        </router-link>
        <router-link :to="{ name: 'Slider' }" class="sidebar__link" active-class="sidebar__link--active">
          <span class="material-symbols-outlined">view_carousel</span>
          <span>Slider</span>
        </router-link>
      </nav>
      <div class="sidebar__user" role="button" tabindex="0" @click="openUserDrawer" @keydown.enter.prevent="openUserDrawer">
        <div class="sidebar__user-avatar" />
        <div class="sidebar__user-info">
          <p class="sidebar__user-name">{{ userDisplayName }}</p>
          <p class="sidebar__user-role">Admin</p>
        </div>
      </div>
      <button type="button" class="sidebar__logout" @click="logout">
        <span class="material-symbols-outlined">logout</span>
        <span>Logout</span>
      </button>
    </aside>
    <main class="main">
      <div class="main__content">
        <router-view :key="$route.fullPath" />
      </div>
    </main>

    <el-drawer
      :visible.sync="userDrawerVisible"
      direction="rtl"
      size="400px"
      class="user-drawer"
      @open="userDrawerOpen"
    >
      <template slot="title">
        <div class="user-drawer__header">
          <div class="user-drawer__header-avatar" />
          <div class="user-drawer__header-info">
            <p class="user-drawer__header-name">{{ userDisplayName }}</p>
            <p class="user-drawer__header-role">Admin</p>
          </div>
        </div>
      </template>
      <div class="user-drawer__content">
        <template v-if="drawerView === null">
          <button type="button" class="user-drawer__option" @click="openGeneralView">
            <span class="material-symbols-outlined user-drawer__option-icon">person</span>
            <span>General Information</span>
          </button>
          <button type="button" class="user-drawer__option" @click="drawerView = 'password'">
            <span class="material-symbols-outlined user-drawer__option-icon">lock</span>
            <span>Change Password</span>
          </button>
        </template>

        <template v-else-if="drawerView === 'general'">
          <button type="button" class="user-drawer__back" @click="drawerView = null">
            <span class="material-symbols-outlined">arrow_back</span>
            Back
          </button>
          <section class="user-drawer__section">
            <h3 class="user-drawer__section-title">General Information</h3>
            <form class="user-drawer__form" @submit.prevent="submitGeneralInfo">
              <div class="user-drawer__field">
                <label class="user-drawer__label" for="general-first-name">First Name</label>
                <el-input id="general-first-name" v-model="generalForm.firstName" placeholder="First name" />
              </div>
              <div class="user-drawer__field">
                <label class="user-drawer__label" for="general-last-name">Last Name</label>
                <el-input id="general-last-name" v-model="generalForm.lastName" placeholder="Last name" />
              </div>
              <div class="user-drawer__field">
                <label class="user-drawer__label" for="general-email">Email</label>
                <el-input id="general-email" v-model="generalForm.email" type="email" placeholder="Email" />
              </div>
              <div class="user-drawer__field">
                <label class="user-drawer__label" for="general-username">Username</label>
                <el-input id="general-username" v-model="generalForm.username" placeholder="Username" />
              </div>
              <el-button type="primary" native-type="submit" :loading="generalSubmitting">Save</el-button>
            </form>
          </section>
        </template>

        <template v-else-if="drawerView === 'password'">
          <button type="button" class="user-drawer__back" @click="drawerView = null">
            <span class="material-symbols-outlined">arrow_back</span>
            Back
          </button>
          <section class="user-drawer__section">
            <h3 class="user-drawer__section-title">Change Password</h3>
            <form class="user-drawer__form" @submit.prevent="submitChangePassword">
              <div class="user-drawer__field">
                <label class="user-drawer__label" for="current-password">Current Password</label>
                <el-input
                  id="current-password"
                  v-model="passwordForm.currentPassword"
                  type="password"
                  autocomplete="current-password"
                  placeholder="Current password"
                  show-password
                />
              </div>
              <div class="user-drawer__field">
                <label class="user-drawer__label" for="new-password">New Password</label>
                <el-input
                  id="new-password"
                  v-model="passwordForm.newPassword"
                  type="password"
                  autocomplete="new-password"
                  placeholder="New password"
                  show-password
                />
              </div>
              <div class="user-drawer__field">
                <label class="user-drawer__label" for="confirm-password">Confirm New Password</label>
                <el-input
                  id="confirm-password"
                  v-model="passwordForm.confirmPassword"
                  type="password"
                  autocomplete="new-password"
                  placeholder="Confirm new password"
                  show-password
                />
              </div>
              <el-button type="primary" native-type="submit" :loading="passwordSubmitting">
                Change Password
              </el-button>
            </form>
          </section>
        </template>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from 'axios'
import { Drawer, Input, Button, Message } from 'element-ui'

export default {
  name: 'AdminLayout',

  components: {
    'el-drawer': Drawer,
    'el-input': Input,
    'el-button': Button
  },

  data () {
    return {
      userDrawerVisible: false,
      drawerView: null,
      me: {},
      generalForm: {
        firstName: '',
        lastName: '',
        email: '',
        username: ''
      },
      generalSubmitting: false,
      passwordForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordSubmitting: false
    }
  },

  created () {
    this.fetchMe()
  },

  computed: {
    isManageMenuActive () {
      const name = this.$route.name
      return name === 'Dashboard' || name === 'ManageMenuAdd' || name === 'ManageMenuEdit'
    },
    userDisplayName () {
      const first = (this.me.firstName || '').trim()
      const last = (this.me.lastName || '').trim()
      if (first || last) return [first, last].filter(Boolean).join(' ')
      return this.me.username || 'Administrator'
    }
  },

  methods: {
    openUserDrawer () {
      this.userDrawerVisible = true
      this.fetchMe()
    },

    userDrawerOpen () {
      this.drawerView = null
    },

    openGeneralView () {
      this.syncGeneralFormFromMe()
      this.drawerView = 'general'
    },

    fetchMe () {
      axios.get('/api/auth/me').then((res) => {
        if (res.data && res.data.data) {
          const d = res.data.data
          this.me = {
            id: d.id,
            username: d.username,
            firstName: d.first_name || '',
            lastName: d.last_name || '',
            email: d.email || ''
          }
          this.syncGeneralFormFromMe()
        }
      }).catch(() => {
        this.me = {}
      })
    },

    syncGeneralFormFromMe () {
      this.generalForm = {
        firstName: this.me.firstName || '',
        lastName: this.me.lastName || '',
        email: this.me.email || '',
        username: this.me.username || ''
      }
    },

    submitGeneralInfo () {
      const { firstName, lastName, email, username } = this.generalForm
      if (!(username && username.trim())) {
        Message.warning('Username is required')
        return
      }
      this.generalSubmitting = true
      axios.put('/api/auth/me', {
        first_name: (firstName || '').trim(),
        last_name: (lastName || '').trim(),
        email: (email || '').trim(),
        username: username.trim()
      }).then((res) => {
        Message.success('Profile updated')
        if (res.data && res.data.data) {
          const d = res.data.data
          this.me = {
            id: d.id,
            username: d.username,
            firstName: d.first_name || '',
            lastName: d.last_name || '',
            email: d.email || ''
          }
        }
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.error) || 'Failed to update profile'
        Message.error(msg)
      }).finally(() => {
        this.generalSubmitting = false
      })
    },

    submitChangePassword () {
      const { currentPassword, newPassword, confirmPassword } = this.passwordForm
      if (!currentPassword || !newPassword || !confirmPassword) {
        Message.warning('Please fill in all password fields')
        return
      }
      if (newPassword !== confirmPassword) {
        Message.warning('New password and confirmation do not match')
        return
      }
      if (newPassword.length < 6) {
        Message.warning('New password must be at least 6 characters')
        return
      }
      this.passwordSubmitting = true
      axios.post('/api/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword
      }).then(() => {
        Message.success('Password changed successfully')
        this.passwordForm = { currentPassword: '', newPassword: '', confirmPassword: '' }
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.error) || 'Failed to change password'
        Message.error(msg)
      }).finally(() => {
        this.passwordSubmitting = false
      })
    },

    logout () {
      localStorage.removeItem('token')
      this.$root.$emit('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-layout {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background-color: #FAFAFA;
  font-family: 'Manrope', sans-serif;
}

.sidebar {
  width: 18rem;
  flex-shrink: 0;
  background-color: #FFFFFF;
  border-right: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
}

.sidebar__brand {
  padding: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.sidebar__logo {
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 0.75rem;
  background-color: #1a1a1a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  padding: 0.375rem;
  box-sizing: border-box;
  .material-symbols-outlined {
    font-size: 1.25rem;
  }
}

.sidebar__logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.sidebar__title {
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #0f172a;
  padding-left: 0.25rem;
  padding-right: 0.5rem;
}

.sidebar__nav {
  flex: 1;
  padding: 0 1.5rem;
  padding-top: 0;
}

.sidebar__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #94a3b8;
  padding: 0 1rem;
  margin-bottom: 1rem;
  margin-top: 2rem;
  &:first-child {
    margin-top: 0;
  }
}

.sidebar__link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  color: #64748b;
  text-decoration: none;
  font-size: 0.875rem;
  transition: all 0.15s ease;
  .material-symbols-outlined {
    font-size: 1.375rem;
  }
  &:hover {
    background-color: #f8fafc;
    color: #0f172a;
  }
  &--active {
    background-color: #f8fafc;
    color: #0f172a;
    font-weight: 600;
  }
}

.sidebar__user {
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 0 0.5rem 1rem;
  padding: 0.75rem;
  border-radius: 1rem;
  background-color: rgba(248, 250, 252, 0.5);
  border: 1px solid #f1f5f9;
  cursor: pointer;
  transition: border-color 0.15s;
  &:hover {
    border-color: #e2e8f0;
  }
}

.sidebar__user-avatar {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 9999px;
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  flex-shrink: 0;
}

.sidebar__user-info {
  flex: 1;
  min-width: 0;
}

.sidebar__user-name {
  font-size: 0.75rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar__user-role {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 500;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar__logout {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  margin: 0 1.5rem 1.5rem;
  border: none;
  border-radius: 0.75rem;
  background: transparent;
  color: #64748b;
  font-size: 0.875rem;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.15s ease;
  .material-symbols-outlined {
    font-size: 1.375rem;
  }
  &:hover {
    background-color: #f8fafc;
    color: #0f172a;
  }
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.main__content {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.user-drawer__header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.user-drawer__header-avatar {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 9999px;
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  flex-shrink: 0;
}

.user-drawer__header-info {
  flex: 1;
  min-width: 0;
}

.user-drawer__header-name {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-drawer__header-role {
  font-size: 10px;
  color: #94a3b8;
  font-weight: 500;
  margin: 0;
}

.user-drawer__content {
  padding: 0 0.5rem;
}

.user-drawer__option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 0;
  margin-bottom: 0.25rem;
  border: none;
  border-radius: 0.75rem;
  background: transparent;
  color: #64748b;
  font-size: 0.875rem;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s;
  .material-symbols-outlined {
    font-size: 1.25rem;
  }
  &:hover {
    background-color: #f8fafc;
    color: #0f172a;
  }
}

.user-drawer__option-icon {
  color: #94a3b8;
}

.user-drawer__back {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0 1rem;
  margin-bottom: 0.5rem;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 0.875rem;
  font-family: inherit;
  cursor: pointer;
  .material-symbols-outlined {
    font-size: 1.25rem;
  }
  &:hover {
    color: #0f172a;
  }
}

.user-drawer__section {
  margin-bottom: 2rem;
  &:last-child {
    margin-bottom: 0;
  }
}

.user-drawer__section-title {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #94a3b8;
  margin: 0 0 1rem;
}

.user-drawer__fields {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.25rem 1.5rem;
  margin: 0;
}

.user-drawer__label {
  font-size: 0.8125rem;
  color: #64748b;
  margin: 0;
}

.user-drawer__value {
  font-size: 0.875rem;
  color: #0f172a;
  margin: 0;
}

.user-drawer__form .user-drawer__field {
  margin-bottom: 1rem;
}

.user-drawer__form .user-drawer__label {
  display: block;
  margin-bottom: 0.375rem;
}

.user-drawer__form .el-button {
  margin-top: 0.25rem;
}
</style>
